import { Deserializable } from '../protocols/deserializable';
import { GoverningJurisdictionTypeId } from '../enum/shared/governing-jurisdiction-type-id';
import { GoverningJurisdictionType } from '../employers/employer-history/types/governing-jurisdiction-type';
import { WithdrawalInstruction } from '../submissions/withdrawal-instruction';
import { VbAccountAnnualDetails } from './vb-account-annual-details';
import { VbRecurringPaymentInstruction } from './vb-recurring-payment-instruction';
import { VbLumpSumPaymentInstruction } from './vb-lump-sum-payment-instruction';

export class VariableBenefitAccountDetails implements Deserializable {
  public id!: number;
  public accountId!: number;
  public isSpousal!: boolean;
  public governingJurisdictionId!: GoverningJurisdictionTypeId | null;
  public governingJurisdiction!: GoverningJurisdictionType | null;
  public effectiveDate!: string;
  public totalBalance!: number;
  public nextPaymentDate!: string;
  public nextPaymentAmount!: number;
  public yearToDatePaymentAmount!: number | null;
  public jurisdictionHasPreviouslyUnlockedFunds!: boolean;
  public paymentBankAccountId!: number | null;
  public paymentBankAccountNickname!: string | null;
  public currentYearAnnualDetails!: VbAccountAnnualDetails | null;
  public nextYearAnnualDetails!: VbAccountAnnualDetails | null;
  public activeRecurringPaymentInstruction!: VbRecurringPaymentInstruction | null;
  public scheduledRecurringPaymentInstruction!: VbRecurringPaymentInstruction | null;
  public scheduledLumpSumPaymentInstruction!: VbLumpSumPaymentInstruction | null;
  public historicalLumpSumPayments!: VbLumpSumPaymentInstruction[];
  public withdrawalInstructions!: WithdrawalInstruction[];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.governingJurisdiction) {
      this.governingJurisdiction = Deserialize.instanceOf(GoverningJurisdictionType, this.governingJurisdiction);
    }

    if (this.currentYearAnnualDetails) {
      this.currentYearAnnualDetails = Deserialize.instanceOf(VbAccountAnnualDetails, this.currentYearAnnualDetails);
    }

    if (this.nextYearAnnualDetails) {
      this.nextYearAnnualDetails = Deserialize.instanceOf(VbAccountAnnualDetails, this.nextYearAnnualDetails);
    }

    if (this.activeRecurringPaymentInstruction) {
      this.activeRecurringPaymentInstruction = Deserialize.instanceOf(
        VbRecurringPaymentInstruction,
        this.activeRecurringPaymentInstruction
      );
    }

    if (this.scheduledRecurringPaymentInstruction) {
      this.scheduledRecurringPaymentInstruction = Deserialize.instanceOf(
        VbRecurringPaymentInstruction,
        this.scheduledRecurringPaymentInstruction
      );
    }

    if (this.scheduledLumpSumPaymentInstruction) {
      this.scheduledLumpSumPaymentInstruction = Deserialize.instanceOf(
        VbLumpSumPaymentInstruction,
        this.scheduledLumpSumPaymentInstruction
      );
    }

    if (this.historicalLumpSumPayments) {
      this.historicalLumpSumPayments = Deserialize.arrayOf(VbLumpSumPaymentInstruction, this.historicalLumpSumPayments);
    }

    if (this.withdrawalInstructions) {
      this.withdrawalInstructions = Deserialize.arrayOf(WithdrawalInstruction, this.withdrawalInstructions);
    }
  }
}
